import {
  Flex,
  Heading,
  Icon,
  Image,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import PartyPopperImage from "assets/icons/party-popper.png";
import { ReactSVG } from "react-svg";
import { useLocation } from "react-router-dom";

export interface CallbackSuccessContent {
  title: string;
  description: string;
}

const CallbackSuccess = () => {
  const { search } = useLocation();

  const [title, setTitle] = useState<string>("Success!");
  const [description, setDescription] = useState<string>(
    "Whatever you were doing, it worked!"
  );

  const queryParams = new URLSearchParams(search);
  const integration = queryParams.get("integration");

  useEffect(() => {
    const content = localStorage.getItem("callback_success");

    if (content) {
      try {
        const { title: parsedTitle, description: parsedDescription } =
          JSON.parse(content) as CallbackSuccessContent;

        setTitle(parsedTitle);
        setDescription(parsedDescription);
      } catch (e: unknown) {
        // eslint-disable-next-line
        console.error(e);
      } finally {
        localStorage.removeItem("callback_success");
      }
    } else if (integration) {
      setTitle(`Success!`);
      setDescription(
        `Your ${integration} integration has been successfully connected.`
      );
    }
  }, []);

  const { colorMode } = useColorMode();

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      direction="column"
      p={8}
      textAlign="center"
    >
      <Icon
        w="5rem"
        h="5rem"
        as={ReactSVG}
        __css={{
          svg: {
            height: "5rem",
            width: "5rem",
          },
        }}
        src={
          colorMode === "dark" ? "/fuzey-target-light.svg" : "/fuzey-target.svg"
        }
      />
      <Heading my={8} size="xl">
        {title}
      </Heading>
      <Image src={PartyPopperImage} />
      <Heading
        mt={8}
        size="lg"
        fontWeight={900}
        color={colorMode === "dark" ? "gray.200" : "gray.500"}
      >
        Feel free to close this tab now
      </Heading>
      <Text color="gray.300">{description}</Text>
    </Flex>
  );
};

export default CallbackSuccess;
